<div class="container-sm">
  <div class="row">
    <div class="teaser-container" [class.inverted]="data.inverted || inverted">
      <mb-card
        [data]="data.heroTeaser"
        [layouts]="largeLayouts"
        [actions]="data.heroTeaser.actions"
        alignContent="bottom"
      >
        <figure>
          <mb-media [media]="data.heroTeaser.media" [hoverplay]="true"></mb-media>
        </figure>
      </mb-card>
      @for (item of data.teasers; track $index) {
        <mb-card
          (click)="openCardMedia(item)"
          class="small-teaser"
          [data]="item"
          [layouts]="smallLayout"
          [actions]="item.actions"
          alignContent="top"
        >
          <figure>
            <mb-media [media]="item.media" [hoverplay]="true"></mb-media>
          </figure>
        </mb-card>
      }
    </div>
  </div>
</div>
